/**
 * Step 7 — Setup complete.
 *
 * Persists the run-once `setup_completed` flag (idempotent) and lets the user
 * enter the application. Because login already happened in Step 4, the user is
 * authenticated and lands directly in the app.
 */

import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import sx from '../setupStyles';
import { setupApi } from '../desktopApi';

export default function Complete({ onComplete }) {
  const [saving, setSaving] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await setupApi.complete();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[setup] complete flag failed', err);
      } finally {
        if (!cancelled) setSaving(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Box sx={sx.body}>
        <Box sx={sx.centerCol} alignItems="center" textAlign="center">
          <CheckCircleIcon color="success" sx={{ fontSize: 56 }} />
          <Typography variant="h5" fontWeight={600}>
            Setup completed successfully
          </Typography>
          <Typography color="text.secondary">
            Your desktop application is now ready. You can work online, continue working offline,
            and changes synchronize automatically whenever an internet connection is available.
          </Typography>
        </Box>
      </Box>
      <Box sx={sx.footer}>
        <span />
        <Button variant="contained" onClick={onComplete} disabled={saving}>
          {saving ? 'Finishing…' : 'Continue to Application'}
        </Button>
      </Box>
    </>
  );
}
